module.exports = __webpack_public_path__ + "static/media/section-4.60dca116.png";